// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AuthErrorModalLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-autherrormodal" */ "@ms/planner-presentational-controls/lib/local/authErrorModal/AuthErrorModal")).then((bundle)=>{
        return {
            default: bundle.AuthErrorModal
        };
    });
export const LazyAuthErrorModal = /*#__PURE__*/ lazy(AuthErrorModalLazyLoader);
